import type { ReactElement } from 'react';
import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { DiscountCodesPage } from './DiscountCodesPage';
import { GiftVoucherPage } from './GiftVoucherPage';
import { GiftVouchersPage } from './GiftVouchersPage';

const gate = (permission: string, element: ReactElement) => <ModuleGate module="vouchers" permission={permission}>{element}</ModuleGate>;

/**
 * Einstiegspunkt des Moduls Gutscheine im Backoffice (Schlüssel `vouchers`, siehe docs/gutscheine.md), Abteilung CRM. Gutscheine mit Guthaben unter /gutscheine, die festen Rabattcodes für die
 * Fahrgast-App (früher ebenfalls „Gutscheine“) unter /rabattcodes.
 */
export const vouchersModule: BackofficeModule = {
  key: 'vouchers',
  path: '/gutscheine',
  nav: [
    { label: 'Gutscheine', path: '/gutscheine' },
    { label: 'Rabattcodes', path: '/rabattcodes' },
  ],
  routes: (
    <>
      <Route path="gutscheine" element={gate('vouchers.read', <GiftVouchersPage />)} />
      <Route path="gutscheine/:id" element={gate('vouchers.read', <GiftVoucherPage />)} />
      <Route path="rabattcodes" element={gate('vouchers.read', <DiscountCodesPage />)} />
    </>
  ),
};
